import SuperRepository from '../superRepository'

export default new (class PartnersSpendsRepository extends SuperRepository {
  baseUri() {
    return 'partner_spend'
  }
  getTableData = params => this.httpClient().get(`${this.baseUri()}/table`, params)
  updateTableData = params => this.httpClient().putQuery(`${this.baseUri()}/update_table`, {}, params, { skip403Redirect: true })
  updateSpendByPartner = params => this.httpClient().put(`${this.baseUri()}/update_spend_by_partner`, params)
  updateSpendByStreamAndCountry = params => this.httpClient().put(`${this.baseUri()}/update_spend_by_stream_and_country`, params)
})()
